import React, { useEffect } from "react";
import { Offcanvas, Table } from "react-bootstrap";
import { MdRestore } from "react-icons/md";
import { NoDataFoundTable } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const DeletedFormMetadata = ({
  tableRef,
  onMouseDown,
  formDeletedMetadata,
  softDeleteRestoreStudyLevelForm,
  Show,
  Hide,
  Title,
  pageNumberDeleted,
  itemsPerPageDeleted,
  getDeletedStudyLevelForm,
}) => {
  const startIndex = (pageNumberDeleted - 1) * itemsPerPageDeleted;
  useEffect(() => {
    getDeletedStudyLevelForm(pageNumberDeleted, itemsPerPageDeleted);
  }, [pageNumberDeleted, itemsPerPageDeleted]);
  return (
    <>
      <Offcanvas
        show={Show}
        onHide={Hide}
        style={{ width: 575 }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {formDeletedMetadata?.length === 0 ? (
            <div
              className="hstack justify-content-center"
              style={{ height: "calc(100vh - 44px)" }}
            >
              <NoDataFoundTable MSG={"From metadata not deleted yet."} />
            </div>
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Form Name</th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>Form Type</th>
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>Special Form</th>
                    <th onMouseDown={(e) => onMouseDown(e, 4)}>Initiate Form</th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 4)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Restore
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {formDeletedMetadata?.map((metadata, index) => (
                    <tr key={index} title="View Details">
                      <td className="text-center">{index + 1 + startIndex}.</td>
                      <td>{metadata?.formName}</td>
                      <td className="text-capitalize">{metadata?.formType}</td>
                      <td className="text-capitalize">
                        {metadata?.specialForm}
                      </td>
                      <td className="text-capitalize">
                        {metadata?.initiateForm}
                      </td>
                      <td className="text-center" title="Restore">
                        <MdRestore
                          style={{ fontSize: 16 }}
                          onClick={(e) =>
                            softDeleteRestoreStudyLevelForm(
                              metadata?._id,
                              "restore"
                            )
                          }
                          className="text-success CP"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default DeletedFormMetadata;
